import {ViewDocumentPanel} from "base/file/components";

// TO-DO: Consider removing intermediate component if not needed

const ViewApprovedPermitDocumentPanel = () => {
    return <ViewDocumentPanel />;
};

export default ViewApprovedPermitDocumentPanel;
